import React from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import CaseComponent from "../common/CaseComponent";

const getPrintCaseHeader = (props) => (
  <Table.Row>
    <Table.Cell>
      <div className={`no-print`}>
        <Button
          className={"margin-left-10"}
          onClick={() => {
            props.printContent("report", `Report`);
          }}
        >
          Print
        </Button>
      </div>
    </Table.Cell>
    <Table.Cell />
    <Table.Cell textAlign={`right`}>
      <div className={`no-print `}>
        <CaseComponent
          {...props}
          actId={_.get(
            props.reportData,
            `${Object.keys(props.reportData)[0]}.log[0].actID[0]`
          )}
        />
      </div>
    </Table.Cell>
  </Table.Row>
);

export default getPrintCaseHeader;



// WEBPACK FOOTER //
// ./src/components/reports/PrintCaseHeader.js